const steps = [
    {
        key: 'details',
        name: 'stage_details',
        componentName: 'EditProgramStageDetails',
    },
    {
        key: 'assign_data_elements',
        name: 'assign_data_elements',
        componentName: 'AssignProgramStageDataElements',
    },
    {
        key: 'create_data_entry_form',
        name: 'create_data_entry_form',
        componentName: 'CreateDataEntryForm',
    },
];

export default steps;



// WEBPACK FOOTER //
// ./src/EditModel/event-program/tracker-program/program-stages/programStageSteps.js